export const tablePageRows = [15, 50, 100];
export const defaultRows = 15;
export const LANGUAGE_CODE = 'en-US';
export const REGION = 'us-east-2';
export const AWS4 = 'AWS4';
export const TENANTS_REVONE_COMPANIES = 'Tenants / RevOne Companies';
